import React, { FC, useEffect, useState } from 'react';
import { isTouchDevice, Tooltip } from '@investoro/core';
import styled from 'styled-components';

import Icon, { IconEnum } from 'components/common/Icon';

const MetaValueWrapper = styled.span<{ aiBg?: boolean; isHovered: boolean; }>`
    display: flex;
    gap: 6px;
    padding: 2px 6px;
    border-radius: 6px;
    cursor: pointer;

    width: fit-content;
    
    img {
        width: 20px;
        height: 20px;
    }

    ${({ aiBg }) => aiBg &&
        `
        background-color: var(--background-color-ai);
        font-style: italic;
    `}
`;

const MetaKeyValueWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    padding-left: 15px;
    margin-bottom: 8px;
    align-items: center;
    
    b {
        font-weight: 600;
    }
`;

export interface MetaValueElementProperties {
    metaKey: string;
    value?: string;
    aiValue?: string;
}

const MetaValueElement: FC<MetaValueElementProperties> = ({
    metaKey,
    value,
    aiValue
}) => {
    const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(null);
    const [showTooltip, setShowTooltip] = useState(false);
    const [isTouch, setIsTouch] = useState(false);

    const handleShowTooltipToggle = (e: React.MouseEvent | React.TouchEvent) => {
        e.stopPropagation();
        if (isTouch) setShowTooltip((prev) => !prev);
    };

    useEffect(() => {
        setIsTouch(isTouchDevice());
    }, []);
    const tooltipText = 'Dane wygenerowane przez AI';

    return (
        <MetaKeyValueWrapper>
            <b>{metaKey}:</b>
            <MetaValueWrapper>
                <span>{value}</span>
            </MetaValueWrapper>
            {aiValue && <>
                <MetaValueWrapper
                    ref={setReferenceElement}
                    aiBg={true}
                    onClick={handleShowTooltipToggle}
                    onMouseEnter={() => !isTouch && setShowTooltip(true)}
                    onMouseLeave={() => !isTouch && setShowTooltip(false)}
                >
                    <span>
                        {aiValue}
                    </span>
                    {<Icon icon={IconEnum.AI_STARS} />}
                </MetaValueWrapper>
                {showTooltip && <Tooltip text={tooltipText} referenceElement={referenceElement} showTooltip={showTooltip} />}
            </>}

        </MetaKeyValueWrapper>
    );
};

export default MetaValueElement;
